import { computed, ref } from "vue";
import { includes } from "ramda";

export default function setup(roles) {
  const searchable = ref(true);
  const searchText = ref(null);
  const rolesItems = computed(() => roles.value);
  const handleInput = (key, value) =>
    handleSearch(rolesItems.value, "caption", value);
  const handleRecursiveParent = (items, parentId) => {
    for (const item of items) {
      const matched = item.id === parentId;
      if (matched) {
        item.show = true;
      } else {
        const { children } = item;
        if (children.length) {
          return handleRecursiveParent(children, parentId);
        }
      }
    }
  };
  const handleSearch = (items, searchKey, searchValue) => {
    return items.reduce((newRoles, currentRole) => {
      const { parentId, children } = currentRole;

      const matched = includes(searchValue, currentRole[searchKey]);
      currentRole.show = matched;
      if (matched) {
        handleRecursiveParent(items, parentId);
      }

      if (children.length) {
        newRoles.push(...handleSearch(children, searchKey, searchValue));
      }
      return newRoles;
    }, []);
  };

  return {
    searchable,
    searchText,
    rolesItems,
    handleInput,
  };
}
